import * as React from 'react';

interface Props {
  condition?: boolean;
}

export const Put: React.FC<React.PropsWithChildren<Props>> = ({ condition = true, children }) => {
  return <>{condition && children ? children : '---'}</>;
};
